module.exports = __webpack_public_path__ + "img/chess-pawn.aa518c70.svg";